export function getPercentagesFromValues(values, minValue, maxValue) {
    return [
        getPercentageFromValue(values[0], minValue, maxValue),
        getPercentageFromValue(values[1], minValue, maxValue),
    ];
}

export function getActiveTrackStyle(percentages) {
    const width = `${(percentages[1] - percentages[0]) * 100}%`;
    const left = `${percentages[0] * 100}%`;

    return { left, width };
}

export function FormatLabel(milliSeconds) {
    let seconds = Math.floor((milliSeconds / 1000) % 60);
    let minutes = Math.floor((milliSeconds / (1000 * 60)) % 60);

    if (seconds < 10) seconds = "0" + seconds;
    if (minutes < 10) minutes = "0" + minutes;
    return `${minutes}:${seconds}`
}


export function getPercentageFromValue(value, minValue, maxValue) {
    const validValue = clamp(value, minValue, maxValue);
    const valueDiff = maxValue - minValue;
    const valuePerc = (validValue - minValue) / valueDiff;

    return valuePerc || 0;
}

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}